import * as config from "./config";

export const Cargo = {
  config,
};
